exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list {\n    position: relative;\n    border-radius: 0.2em;\n    margin: 0.5em;\n    /*box-shadow: 0 1px 3px 1px #999;*/\n    padding: 1px;\n    background-color: #CCC;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n}", ""]);
